import { TreeNode } from '@/store/tree/types';

const SELECTED_NODES_KEY = 'MedsafeSelectedNodes';
const TREE_NODE_KEY = 'MedsafeTreeNode';
const ORG_ID_KEY = 'MedsafeTreeNodeOrgId';

interface PersistedTreeState {
  orgId: number | null;
  selectedNodesIds: string[];
  treeNode: string;
}

export function saveSelectedNodes(
  selectedNodesMap: TreeNode[],
  userId: number,
  orgId: number | null,
): void {
  try {
    if (userId) {
      const selectedNodesIds = selectedNodesMap
        .filter((node) => node.id_tree !== '0')
        .map((node) => node.id_tree);

      const state: PersistedTreeState = {
        orgId,
        selectedNodesIds,
        treeNode: orgId ? orgId.toString() : '0',
      };
      localStorage.setItem(
        `${SELECTED_NODES_KEY}-${userId}`,
        JSON.stringify(state),
      );
    }
  } catch (error) {
    console.error(error);
  }
}

export function saveTreeNode(
  treeNode: string,
  userId: number,
  orgId: number | null,
): void {
  try {
    if (userId && orgId) {
      localStorage.setItem(
        `${TREE_NODE_KEY}-${userId}`,
        JSON.stringify(treeNode),
      );
      localStorage.setItem(
        `${ORG_ID_KEY}-${userId}`,
        JSON.stringify(orgId),
      );
    }
  } catch (error) {
    console.error(error);
  }
}

export function restoreSelectedNodesIds(userId: number, currentOrgId: number | null): string[] {
  try {
    if (userId) {
      const stored = localStorage.getItem(`${SELECTED_NODES_KEY}-${userId}`);
      if (stored) {
        const state = JSON.parse(stored) as PersistedTreeState;
        if (state.orgId === currentOrgId) {
          return state.selectedNodesIds || [];
        }
      }
    }
  } catch (error) {
    console.error(error);
  }
  return [];
}

export function restoreTreeNode(userId: number, currentOrgId: number | null): string {
  try {
    if (userId) {
      const savedOrgId = localStorage.getItem(`${ORG_ID_KEY}-${userId}`);
      if (savedOrgId && JSON.parse(savedOrgId) === currentOrgId) {
        const stored = localStorage.getItem(`${TREE_NODE_KEY}-${userId}`);
        if (stored) {
          return JSON.parse(stored) as string;
        }
      }
    }
  } catch (error) {
    console.error(error);
  }
  return '0';
}

export function clearTreeState(userId: number): void {
  try {
    if (userId) {
      localStorage.removeItem(`${SELECTED_NODES_KEY}-${userId}`);
      localStorage.removeItem(`${TREE_NODE_KEY}-${userId}`);
      localStorage.removeItem(`${ORG_ID_KEY}-${userId}`);
    }
  } catch (error) {
    console.error(error);
  }
}
